import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import stateStore from "../../store/stateStore";
import IsdCheckBox from "./isdCheckBox";
import IsdSelectBox from "./isdselectbox"
import IsdTextBox from "./isdTextBox";
import IsdTextboxYmd from "./IsdTextboxYmd";
import myGrid from "../../store/myGridStore";
import { observer } from "mobx-react";
import IsdDoubleTextbox from "./IsdDoubleTextbox";

const MultiEditor = observer((props) => {
    const ref = useRef(null);
    const [component, setComponent] = useState('');
    const [value, setValue] = useState('');
    useEffect(() => {
        setValue(props.value);
    }, [props.value]);
    useEffect(() => {
        if (!props.editor) return;
        let component = '';
        let valueBf = props.value;
        if (props.editor.component) {
            component = props.editor.component;
        }
        if (props.editor.changeEditorFunc) {
            const { componentAf, valueAf } = props.editor.changeEditorFunc(props.rows.row, props.rows.cell, props.name, props.row.original);
            component = componentAf ? componentAf : '';
            valueBf = valueAf ? valueAf : '';
        } else if (props.editor.value && !props.value) {
            valueBf = props.editor.value;
        }
        setValue(valueBf);
        setComponent(component);
    }, []);
    const onClick = (event) => {
        if (props.editor.clickFunc) {
            props.editor.clickFunc(event, props.rows.row, props.rows.cell, props.name, props.row.original);
        }
    }

    const onChange = (event) => {

        if (props.editor.changeFunc) {
            props.editor.changeFunc(event, props.rows.row, props.rows.cell, props.name, props.row.original, props.updateMyEdits);
        }
        props.onChange(event);
    }

    const onBlur = (event) => {
        if (props.editor.blurFunc) {
            props.editor.blurFunc(event, props.rows.row, props.rows.cell, props.name, props.original, props.updateMyEdits);
        }
    }

    const getValue = () => {
        return myGrid.props.data[props.rows.row] ? myGrid.props.data[props.rows.row][props.name] : value;
    }

    const getKbnValue = () => {
        if (props.data && props.data[props.editor.data]) {
            return props.data[props.editor.data];
        }
        if (stateStore.state[props.editor.data]) {
            return stateStore.state[props.editor.data];
        }
        return props.editor.data;
    }

    if (component === "selectbox") {
        return (<IsdSelectBox dataGrid defaultkubunindex="-1" name={props.cell.column.id} kbnvalue={getKbnValue()}
            valueField={props.editor.valueField} labelField={props.editor.labelField}
            disabled={props.editor.disabled}
            ref={ref} value={getValue()}
            onChange={onChange} onBlur={onBlur} />)
    } else if (component === "checkbox") {
        return (
            <IsdCheckBox checked={getValue()}
                disabled={props.editor.disabled}
                onChange={(event) => {
                    const eventChange = {
                        target: { value: event.target.checked }
                    };
                    onChange(eventChange);
                }}></IsdCheckBox>
        )
    } else if (component === "button") {
        return <>
            {props.editor.linkTo ? <Link to={props.editor.linkTo(props.rows.row, props.rows.cell, props.name, props.row.original)}>
                <button className="btn btn-outline-primary btn-sm" id={`${props.name}_${props.rows.row}`} onClick={onClick}
                    hidden={props.editor.hidden || (props.editor.hiddenFunc && props.editor.hiddenFunc(props.rows.row, props.rows.cell, props.name, props.row.original))}>{props.editor.view(props.rows.row, props.rows.cell, props.name, props.row.original)}</button>
            </Link> :
                <button className="btn btn-outline-primary btn-sm" id={`${props.name}_${props.rows.row}`} onClick={onClick}
                    hidden={props.editor.hidden || (props.editor.hiddenFunc && props.editor.hiddenFunc(props.rows.row, props.rows.cell, props.name, props.row.original))}>表示</button>
            }
        </>
    } else if (component === "textbox") {
        return <IsdTextBox className='input-grid' dataGrid
            isdmaxlength={props.editor.isdmaxlength}
            maxintlength={props.editor.maxintlength}
            maxdeclength={props.editor.maxdeclength}
            ctrlproptype={props.editor.ctrlproptype}
            padchar={props.editor.padchar}
            disabled={props.editor.disabled}
            value={getValue()}
            onChange={onChange} onBlur={onBlur} />
    } else if (component === 'numberbox') {
        return <IsdTextBox className='input-grid inputtype-number' dataGrid isNotReplaceNoMatchRegexp
            isdmaxlength={props.editor.isdmaxlength}
            maxintlength={props.editor.maxintlength}
            maxdeclength={props.editor.maxdeclength}
            ctrlproptype={props.editor.ctrlproptype}
            padchar={props.editor.padchar}
            disabled={props.editor.disabled}
            value={getValue()} onChange={onChange} onBlur={onBlur} />
    } else if (component === "textboxymd") {
        return <IsdTextboxYmd format="yyyy/MM/dd" dataGrid className="date-field-grid" name={props.cell.column.id} value={value} ref={ref} onChange={onChange}></IsdTextboxYmd>
    } else if (component === "doubletextbox") {
        return <><IsdDoubleTextbox className='input-grid'
            classNamefirst={props.editor.classNamefirst || props.editor.className}
            isdmaxlengthfirst={props.editor.isdmaxlengthfirst || props.editor.isdmaxlength}
            maxintlengthfirst={props.editor.maxintlengthfirst || props.editor.maxintlength}
            maxdeclengthfirst={props.editor.maxdeclengthfirst || props.editor.maxdeclength}
            ctrlproptypefirst={props.editor.ctrlproptypefirst || props.editor.ctrlproptype}
            padcharfirst={props.editor.padcharfirst || props.editor.padchar}
            disabledfirst={props.editor.disabledfirst || props.editor.disabled}
            widthfirst={props.editor.widthfirst || props.editor.width}
            valuefirst={props.editor.valuelast}
            classNamelast={props.editor.classNamelast || props.editor.className}
            isdmaxlengthlast={props.editor.isdmaxlengthlast || props.editor.isdmaxlength}
            maxintlengthlast={props.editor.maxintlengthlast || props.editor.maxintlength}
            maxdeclengthlast={props.editor.maxdeclengthlast || props.editor.maxdeclength}
            ctrlproptypelast={props.editor.ctrlproptypelast || props.editor.ctrlproptype}
            padcharlast={props.editor.padcharlast || props.editor.padchar}
            disabledlast={props.editor.disabledlast || props.editor.disabled}
            widthlast={props.editor.widthlast || props.editor.width}
            valuelast={props.editor.valuelast}
            value={getValue()}
        ></IsdDoubleTextbox></>
    } else {
        return <>{value}</>;
    }
})
export default MultiEditor